// Visit The Stimulus Handbook for more details 
// https://stimulusjs.org/handbook/introduction
// 
// This example controller works with specially annotated HTML like:
//
// <div data-controller="hello">
//   <h1 data-target="hello.output"></h1>
// </div>

import { Controller } from "stimulus"
import Sortable from "sortablejs"
import Rails from "@rails/ujs"

export default class extends Controller {
  connect() {
    let nestedSortableCategories = document.getElementsByClassName("nested-categories");
    let nestedSortableMenuItemsInstances = document.getElementsByClassName("nested-menu-items");

    for (var i = 0; i < nestedSortableCategories.length; i++) {
      new Sortable(nestedSortableCategories[i], {
        group: 'categories',
        handle: '.handle',
        forceFallback: true,
        swapThreshold: 0.5,
        animation: 150,
        fallbackOnBody: true,
        swapThreshold: 0.65,
        onEnd: this.end.bind(this)
      });
    }

    for (var i = 0; i < nestedSortableMenuItemsInstances.length; i++) {
      new Sortable(nestedSortableMenuItemsInstances[i], {
        group: 'menuItems',
        handle: '.handle',
        forceFallback: true,
        swapThreshold: 0.5,
        animation: 150,
        fallbackOnBody: true,
        swapThreshold: 0.65,
        onEnd: this.end.bind(this)
      });
    }
  }

  end(event) {
    let dragUrl = event.item.dataset.dragUrl
    let id = event.item.dataset.id
    let targetId = event.to.dataset.id || ""
    let position = event.newIndex + 1

    let data = new FormData()
    data.append("target_id", targetId)
    data.append("position", position)

    Rails.ajax({
      url: dragUrl.replace(":id", id),
      type: 'PATCH',
      data: data,
    })

  }
}
